import React from 'react'

import Button from 'components/Button'
import IconShareIos7 from 'components/Icons/ShareIos7'
import IconMore from 'components/Icons/More'

import s from './AddToHomeModal.scss'
import cn from 'classnames'
import sText from 'components/Text/Text.scss'
import sLay from 'styles/modules/layout.scss'

// Add to Home screen

export default props => {
  const { modalConfirm, markAsComplete, type } = props
  // type = 'apple' || 'android'

  const isSafari = navigator.userAgent.includes('Safari') && !navigator.userAgent.includes('Chrome')

  const safariIcon = <IconShareIos7 size={24} style={{ marginTop: '-3px' }} />
  const chromeIcon = (
    <IconMore size={24} style={{ marginTop: '-3px', transform: 'rotate(90deg)' }} />
  )

  const icon = isSafari ? safariIcon : chromeIcon

  const getInstruction = () => {
    if (!type) {
      return (
        <div className={sText.descrip2} style={{ margin: '30px 0' }}>
          Tap {icon} and and then <b>Add to Home screen</b>.
        </div>
      )
    }
    return (
      <div className={sText.descrip2} style={{ margin: '30px 0' }}>
        To install Pickle on your phone or tablet, simply open thinkpickle.com.au in your web browser.
        Then...
        <p style={{ marginTop: '25px' }}>
          <b>For Google Chrome:</b>
          <br />
          Tap {chromeIcon} and and then <b>Add to Home screen</b>.
        </p>
        <p>
          <b>For Safari:</b>
          <br />
          Tap {safariIcon} and and then <b>Add to Home screen</b>.
        </p>
      </div>
    )
  }

  return (
    <div
      className={cn(sLay['layout-column'], sLay['layout-align-center-center'], sLay.flex, s.body)}
    >
      <div className={sText.descrip1}>To install the Pickle App:</div>
      {getInstruction()}
      <div className={cn(sLay['layout-xs-column'], sLay['layout-gt-xs-row'])}>
        {type ? (
          <Button
            onClick={() => {
              modalConfirm()
            }}
            color="tertiary"
          >
            Close
          </Button>
        ) : (
          <Button
            onClick={() => {
              modalConfirm()
              markAsComplete()
            }}
            color="tertiary"
          >
            Mark as complete
          </Button>
        )}
      </div>
    </div>
  )
}



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/AddToHome/AddToHomeModal/AddToHomeModal.jsx